module.exports = __webpack_public_path__ + "static/media/transferring.d14fc89f.svg";